import api from "@/api";

export default {
    namespaced: true,
    state: () => ({
        guardianStudents: [], 
        allGuardians: [],
        isLoading: false,
        error: null
    }),
    mutations: {
        SET_GUARDIAN_STUDENTS(state, students) { 
            state.guardianStudents = students;
        },
        SET_ALL_GUARDIANS(state, guardians) {
            state.allGuardians = guardians;
        },
        SET_LOADING(state, isLoading) {
            state.isLoading = isLoading;
        },
        SET_ERROR(state, error) {
            state.error = error;
        },
        ADD_STUDENT(state, student) {
            state.guardianStudents.push(student);
        },
        UPDATE_STUDENT(state, updatedStudent) {
            const index = state.guardianStudents.findIndex(s => s.id === updatedStudent.id);
            if (index !== -1) {
                state.guardianStudents.splice(index, 1, updatedStudent);
            }
        },
        REMOVE_STUDENT(state, studentId) { 
            state.guardianStudents = state.guardianStudents.filter(s => s.id !== studentId);
        },
         CLEAR_GUARDIAN_STUDENTS(state) {
    state.guardianStudents = [];
  },
    },
    actions: {
        async fetchGuardianStudents({ commit }, guardianId) { 
            try {
                commit('SET_LOADING', true);
                const response = await api.get(`/guardians/${guardianId}/students`);
                commit('SET_GUARDIAN_STUDENTS', response.data.data || response.data);
            } catch (error) {
                commit('SET_ERROR', error.response?.data?.message || error.message);
                throw error;
            } finally {
                commit('SET_LOADING', false);
            }
        },
        
        async fetchAllGuardians({ commit }) {
            try {
                commit('SET_LOADING', true);
                const response = await api.get('/guardians/all');
                commit('SET_ALL_GUARDIANS', response.data.data || response.data);
            } catch (error) {
                commit('SET_ERROR', error.response?.data?.message || error.message);
                throw error;
            } finally {
                commit('SET_LOADING', false);
            }
        },
        
async addStudentToGuardian({ commit }, { guardianId, studentId, relationType, isPrimary = false }) {
    try {
        commit('SET_LOADING', true);
        const response = await api.post(`/guardians/${guardianId}/students`, {
            student_id: studentId,
            relation_type: relationType,
            is_primary: isPrimary
        });
        
        commit('ADD_STUDENT', {
            ...response.data.data,
            pivot: {
                relation_type: relationType,
                is_primary: isPrimary
            }
        });
        
        return {
            success: true,
            isPrimary: isPrimary
        };
    } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message);
        throw error;
    } finally {
        commit('SET_LOADING', false);
    }
},
        async updateGuardianStudentRelation({ commit }, { guardianId, studentId, relationType }) {
            try {
                commit('SET_LOADING', true);
                const response = await api.put(`/students/${studentId}/guardians/${guardianId}`, {
                    relation_type: relationType
                });
                commit('UPDATE_STUDENT', response.data);
                return response.data;
            } catch (error) {
                commit('SET_ERROR', error.response?.data?.message || error.message);
                throw error;
            } finally {
                commit('SET_LOADING', false);
            }
        },
        
        async removeStudentFromGuardian({ commit }, { guardianId, studentId }) { // Changed from removeGuardian
            try {
                commit('SET_LOADING', true);
                await api.delete(`/students/${studentId}/guardians/${guardianId}`);
                commit('REMOVE_STUDENT', studentId);
                return { success: true };
            } catch (error) {
                commit('SET_ERROR', error.response?.data?.message || error.message);
                throw error;
            } finally {
                commit('SET_LOADING', false);
            }
        }
    },
    getters: {
        guardianStudents: state => state.guardianStudents, // Changed from studentGuardians
        allGuardians: state => state.allGuardians,
        isLoading: state => state.isLoading,
        getError: state => state.error
    }
};